import type { IconProps } from "./icons";

export const ChevronLeft = ({ className = "w-4 h-4" }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    className={className}
    stroke="currentColor"
    strokeWidth={2}
    fill="none"
  >
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

export const ChevronRight = ({ className = "w-4 h-4" }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    className={className}
    stroke="currentColor"
    strokeWidth={2}
    fill="none"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

export const MoreDots = ({ className = "w-4 h-4" }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    className={className}
    stroke="currentColor"
    strokeWidth={2}
    fill="none"
  >
    <circle cx="12" cy="5" r="1.5" fill="currentColor" />
    <circle cx="12" cy="12" r="1.5" fill="currentColor" />
    <circle cx="12" cy="19" r="1.5" fill="currentColor" />
  </svg>
);
